import { Box } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';

const DisabledTooltipContent = () => (
    <Box data-testid="disabled-tooltip-content" role="tooltip" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <BlockIcon sx={{ color: 'error.main', fontSize: 16 }} />
        <span>This can not be edited</span>
    </Box>
);

export default DisabledTooltipContent;
